export enum OrderingGroupExamsEnum {
    MaisAntigo = 'Mais antigo',
    MaisRecente = 'Mais recente',
}